
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHeadingLineOffIec as ObiHeadingLineOffIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-heading-line-off-iec.js';
 
 
 

 
 export const ObiHeadingLineOffIec = createComponent({
   react: React,
   tagName: 'obi-heading-line-off-iec',
   elementClass: ObiHeadingLineOffIecElement,
   events: {
     
   }
  });
 
 